module.exports = __webpack_public_path__ + "img/section4-parallax2.a58f67da.png";